module.exports = __webpack_public_path__ + "img/logo_makro_creativo_web_color.72010d6d.svg";